/**
 * Compact dashboard numbers at the rendering boundary.
 * Raw chart/legend values stay authoritative for matching, filtering, and aggregation.
 */
export function compactNumber(rawValue) {
  const number = Number(rawValue);
  if (!Number.isFinite(number)) return String(rawValue);

  const magnitude = Math.abs(number);
  if (magnitude >= 1e9) return `${(number / 1e9).toFixed(1).replace(/\.0$/, '')}B`;
  if (magnitude >= 1e6) return `${(number / 1e6).toFixed(1).replace(/\.0$/, '')}M`;
  if (magnitude >= 1e3) return `${(number / 1e3).toFixed(1).replace(/\.0$/, '')}K`;
  if (Number.isInteger(number)) return String(number);
  return String(Number(number.toFixed(3)));
}
